import { render, staticRenderFns } from "./FitnessAssessmentsDetails.vue?vue&type=template&id=fedc6380&scoped=true&"
import script from "./FitnessAssessmentsDetails.vue?vue&type=script&lang=js&"
export * from "./FitnessAssessmentsDetails.vue?vue&type=script&lang=js&"
import style0 from "./FitnessAssessmentsDetails.vue?vue&type=style&index=0&id=fedc6380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedc6380",
  null
  
)

export default component.exports